<section class="app-header">
	<div class="app-header-inner" [ngClass]="{'bg-color-light': ['11','12','13','14','15','16','21'].indexOf(AppConfig.colorOption) >= 0,
          'bg-color-dark': AppConfig.colorOption === '31',
          'bg-color-primary': ['22','32'].indexOf(AppConfig.colorOption) >= 0,
          'bg-color-success': ['23','33'].indexOf(AppConfig.colorOption) >= 0,
          'bg-color-info': ['24','34'].indexOf(AppConfig.colorOption) >= 0,
          'bg-color-warning': ['25','35'].indexOf(AppConfig.colorOption) >= 0,
          'bg-color-danger': ['26','36'].indexOf(AppConfig.colorOption) >= 0}">

		<div class="d-lg-none d-xl-none float-left">
			<button mat-button myToggleOffcanvasNav class="md-button header-icon toggle-sidebar-btn">
				<i class="material-icons text-white">menu</i>
			</button>
		</div>

		<div class="brand d-none d-lg-inline-block d-xl-inline-block" style="width: 250px !important;">
			<div style="font-size: 32px;font-weight: bold;margin: 8px 0 0;">
				<a [routerLink]="['/']" *ngIf="AppConfig.theme == 'light'"
					style="background-color: #ffffff; padding: 4px 7px 7px 7px; margin-right: 15px; border-radius: 10px;">
					<img src="assets/images/logo_{{logo}}.png" width="195" height="45">
				</a>
				<a href="javascript:;" class="collapsednav-toggler" (click)="toggleCollapsedNav()">
					<i style="font-size:16px" class="material-icons"
						*ngIf="this.AppConfig.navCollapsed">radio_button_unchecked</i>
					<i style="font-size:16px" class="material-icons"
						*ngIf="!this.AppConfig.navCollapsed">radio_button_checked</i>
				</a>
			</div>
		</div>

		<div class="top-nav-right">
			<ul class="no-select" style="margin: 0 25px 0 0; padding-inline-start: 0px;">
				<li style="justify-content: center; margin: 0 1em; cursor: pointer; display: flex; flex-direction: column; align-items: flex-end; min-width: 205px;"
					class="list-inline-item" #matHeaderMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="appHeaderMenu">
					<div style="display: block;">
						{{ 'header.bemvindo' | translate}} {{ obterNomeUsuario }}
					</div>
					<div style="display: block; font-size: 12px; text-align: right;" *ngIf="dadosUsuarioLogado">
						{{ dadosUsuarioLogado.usuarioTipoId | usuarioTipo }} - {{ dadosUsuarioLogado.conta.nome }}
					</div>
				</li>
			</ul>
			<mat-menu class="menu-usuario-header" #appHeaderMenu="matMenu" [overlapTrigger]="false">
				<ng-container *ngFor="let menu of menusContexto">
					<ng-container *ngIf="menu.type === LayoutHeaderMenuType.Menu">
						<button mat-menu-item [ngClass]="menu.class" [routerLink]="menu.rota" *ngIf="menu.rota">
							<i class="fa-icon fa" [ngClass]="menu.icone"></i> {{menu.name | translate}}
						</button>
						<button mat-menu-item [ngClass]="menu.class" (click)="menu.acao()" *ngIf="menu.acao">
							<i class="fa-icon fa" [ngClass]="menu.icone"></i> {{menu.name | translate}}
						</button>
					</ng-container>
					<ng-container>
						<hr class="mat-divisoria" *ngIf="menu.type === LayoutHeaderMenuType.Divisoria" />
					</ng-container>
				</ng-container>
			</mat-menu>
		</div>

		<!-- (click)="marcarNotificacaoLida()"
		#matNotificationMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="appNotificationMenu"
		(menuClosed)="onMenuNotificacaoFechado()" -->

		<div class="top-nav-right d-none d-lg-inline-block d-xl-inline-block">
			<ul class="list-unstyled list-inline">
				<li class="list-inline-item">
					<button mat-button class="mat-button header-icon" (click)="notificacoes()">
						<i class="material-icons icon-notification">notifications_none</i>
						<span class="badge alert-notification" *ngIf="novaNotificacao">&nbsp;</span>
					</button>
					<!-- <mat-menu class="notification-menu" #appNotificationMenu="matMenu" xPosition="before"
						yPosition="below" overlapTrigger="false">
						<mat-list dense class="notification-list">
							<mat-list-item class="none-notification-item" *ngIf="notificacao.length == 0">
								<h4 mat-line class="none-notification">{{'header.nenhumAlerta' | translate}}</h4>
							</mat-list-item>
							<mat-list-item class="notification-item"
								[ngClass]="notificacaoTipo[item.notificacaoTipoId].toLowerCase()"
								*ngFor="let item of notificacao" (click)="visualizarNotificacao(item)">
								<mat-icon mat-list-avatar class="icon-label"
									[ngClass]="'icon-' + notificacaoTipo[item.notificacaoTipoId].toLowerCase()">
									{{notificacaoTipoIcone[notificacaoTipo[item.notificacaoTipoId].toLowerCase()]}}
								</mat-icon>
								<h4 mat-line class="title-notification">{{item.notificacaoEventoId | eventoNotificacao}}
								</h4>
								<p mat-line class="text-muted new-notification">{{item.dataEvento | dateFormat:'date'}}
									<span *ngIf="item.novo">{{'header.novo' | translate}}</span>
								</p>
								<p mat-line class="text-muted message-notification">{{item.mensagem}}</p>
							</mat-list-item>
							<mat-list-item class="all-notification" [routerLink]="['/app/notificacao']">
								<h3 mat-line>{{'header.verMais' | translate}}</h3>
							</mat-list-item>
						</mat-list>
					</mat-menu> -->
				</li>
			</ul>
		</div>
		<div class="top-nav-right d-none d-lg-inline-block d-xl-inline-block">
			<span style="    border: 3px solid white; margin-top: 15px; cursor: pointer; height: 26px;	display: block;">
				<img [matMenuTriggerFor]="menu" style="display: block;" src="{{idiomaSelecionado.bandeira}}"
					alt="{{ idiomaSelecionado.nome }}" height="20" width="30">
			</span>

			<mat-menu #menu="matMenu" xPosition="before">
				<button *ngFor="let item of idiomas" mat-menu-item (click)="setLanguage(item)">
					<img src="{{item.bandeira}}" alt="{{ item.nome }}" height="20" width="30"> {{item.nome}}</button>

			</mat-menu>

			<!--
			<ng-select #select [items]="idiomas" [(ngModel)]="idiomaSelecionado" style="margin-top: 12px;"
			name="txt-filtro" bindValue="codigo" [clearable]="false"
			notFoundText="{{'telaPadrao.semDados' | translate}}">
	
			<ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index">
				<div style="text-align:left;">
					<img src="{{item.bandeira}}" alt="{{ item.nome }}" height="20" width="30">
				</div>
				
			</ng-template>
		</ng-select>
		-->
		</div>
	</div>
</section>